import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import '../../versions/v2/capabilities.css'

const ValveDesignPage = () => (
    <V2Layout pageClass="pfc-capabilities">
        <SEO
            title="Design Engineering, Manufacturing & Assembly"
            description="From matching an existing proven design to clean-sheet custom engineering, PFC delivers precision valve solutions with minimal NRE and fast turnaround."
        />
        <section className="pfc-page-hero">
            <div className="pfc-page-hero-inner">
                <p className="v2-section-label">Our Capabilities · 01</p>
                <h1 className="pfc-page-hero-title">Design Engineering, Manufacturing &amp; Assembly</h1>
                <p className="pfc-page-hero-sub">
                    From matching an existing proven design to clean-sheet custom engineering - PFC delivers precision valve solutions with minimal NRE and fast turnaround.
                </p>
            </div>
        </section>

        <section className="cap-section">
            <div className="cap-section-inner">
                <div className="cap-cards-3">
                    <div className="cap-card">
                        <div className="cap-card-icon">⚙️</div>
                        <h3 className="cap-card-title">Existing Design Match</h3>
                        <p className="cap-card-body">
                            PFC's extensive portfolio of proven valve designs allows us to quickly match an existing
                            solution to your requirements - minimizing lead time and non-recurring engineering cost.
                        </p>
                    </div>
                    <div className="cap-card">
                        <div className="cap-card-icon">🔧</div>
                        <h3 className="cap-card-title">Modified Existing Design</h3>
                        <p className="cap-card-body">
                            When a standard design is close but not exact, our engineering team modifies an existing
                            valve for a fast-turn custom solution - balancing development speed with performance optimization.
                        </p>
                    </div>
                    <div className="cap-card">
                        <div className="cap-card-icon">📐</div>
                        <h3 className="cap-card-title">Clean-Sheet Custom Design</h3>
                        <p className="cap-card-body">
                            For unique applications, PFC designs and manufactures components from your specification - from concept and analysis through prototyping, test and production.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <CapabilitySections slug="valve-design" />

        <CapabilityPageNav currentSlug="valve-design" />
    </V2Layout>
)

export default ValveDesignPage
